import Bathroom_F from './mapicons/Bathroom_F.png';
import Bathroom_M from './mapicons/Bathroom_M.png';
import SportBook from './mapicons/SportBook.png';
import SSCLounge from './mapicons/SSCLounge.png';

export const SSCIconArr = [
  {
    name: 'BATHROOM_FEMALE',
    image: Bathroom_F,
  },
  {
    name: 'BATHROOM_MALE',
    image: Bathroom_M,
  },
  {
    name: 'SPORTS_BOOK',
    image: SportBook,
  },
  {
    name: 'LOUNGE_BAR',
    image : SSCLounge
  }
];

export const loadImage = (mapbox: any, imageName: any, key: any) => {
  const img = new Image();
  img.src = imageName;

  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d', { willReadFrequently: true }); // Set the flag
    if (ctx) {
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      mapbox.addImage(key, imageData);
    }
  };

  img.onerror = (error) => {
    console.error('Error loading image:', error);
  };
};

export const addMapSSCImage = (mapbox: any) => {
  for (let index = 0; index < SSCIconArr.length; index++) {
    const eachElement = SSCIconArr[index];
    loadImage(mapbox, eachElement.image, eachElement.name);
  }
};
